module.exports = __webpack_public_path__ + "img/happy-couple.aeda2be7.png";